import { CatalogProductFragment } from '../../../components/types';

export interface ITrackingProductPageBaseParameters {
  productUid: string;
  productName: string;
  productProviderName: string;
  marketingConsent: boolean;
  leadId: string;
  experiment_id: string | undefined;
  variant: string | undefined; // ToDo: Variant type
}

export const createProductBaseParameters = (
  product: CatalogProductFragment,
): Pick<
  ITrackingProductPageBaseParameters,
  'productUid' | 'productName' | 'productProviderName'
> => {
  return {
    productUid: product?.productUid ?? '',
    productName: product?.productName ?? '',
    productProviderName: product?.provider?.providerName ?? '',
  };
};
